import { render, staticRenderFns } from "./BarcodeForm.vue?vue&type=template&id=790c8630&"
import script from "./BarcodeForm.vue?vue&type=script&lang=js&"
export * from "./BarcodeForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports